module.exports = __webpack_public_path__ + "img/ltkover40-2x.846d51c.jpg";